export class StringUtil {

  static takeOnly(str: string | null | undefined, length: number, dots: boolean = false): string {
    if (str == null) str = ''
    let r = str.substr(0, Math.min(length, str.length))
    if (dots && str.length > length) {
      return r + '...'
    }
    return r
  }

  static firstWord(str: string | null | undefined): string {
    if (str == null) str = ''
    let slices: string[] = str.split(' ')
    if (slices.length > 0) return slices[0]
    return ''
  }
}
